export const BILL_LIST_QUERY_KEY = {
  SCAN_BILL_AUDIT_LOGS: 'scanBillAuditLogs',
  BILLS_SCAN_AUDIT_LOG_DISMISS: 'billsScanAuditLogDismiss',
  BILLS_LIST: 'billsList',
  BILLS_USER_PERSIST: 'billsUserPersist',
  BILLS_SUMMARY: 'billsSummary',
};
